class ActiveTabContent {
  constructor(section) {
    this.section = document.querySelector(section);
    if (!this.section) return;
    this.tabs = this.section.querySelectorAll('.oxy-tab');
    this.contents = this.section.querySelectorAll('.oxy-tab-content');
    this.contentsTwo = this.section.querySelectorAll('.customer-experience');
    this.pricingHeader = document.querySelector('.pricing-table-header');
    if (this.tabs.length === 0 || this.contents.length === 0 || 
      this.contentsTwo.length === 0) return; // Exit if no tabs or contents found
    this.tabClick();
    this.onloadTabActive();
  }

  updateUrl(activeIndex) {
    if (!this.pricingHeader) return;
    if (activeIndex === 1) {
      window.location.hash = 'conversation-based-pricing';
      this.pricingHeader.classList.add('conversation-based-pricing');
    } else {
      history.replaceState(null, null, ' ');
      this.pricingHeader.classList.remove('conversation-based-pricing');
    }
    this.updateContent(activeIndex);
  }

  updateContent(activeIndex) {
    this.tabs.forEach((tab) => tab.classList.remove('tab-active'));
    this.contents.forEach((content) =>
      content.classList.add('oxy-tabs-contents-content-hidden')
    );
    this.contentsTwo.forEach((content) =>
      content.classList.add('oxy-tabs-contents-content-hidden')
    );

    this.tabs[activeIndex].classList.add('tab-active');
    this.contents[activeIndex].classList.remove(
      'oxy-tabs-contents-content-hidden'
    );
    this.contentsTwo[activeIndex].classList.remove(
      'oxy-tabs-contents-content-hidden'
    );
  }

  onloadTabActive() {
    const activeIndex =
      window.location.hash === '#conversation-based-pricing' ? 1 : 0;
    if (activeIndex === 1) {
      this.pricingHeader.classList.add('conversation-based-pricing');
    } else {
      this.pricingHeader.classList.remove('conversation-based-pricing');
    }
    this.updateContent(activeIndex);
  }

  tabClick() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => {
        this.updateUrl(index);
      });
    });
  }
}

document.addEventListener('readystatechange', () => {
  if (document.readyState === 'complete') {    
    new ActiveTabContent('.pricing-tabs-section , .pricing-tabs-section-second'); //NOSONAR
  }
});